import React from "react";
import styles from "./SocialFollow.module.css"
import facebookLogo from "../../../assets/images/socialFollow/Facebook_Logo.png";
import instagramLogo from "../../../assets/images/socialFollow/Instagram_Logo.png";
import linkedInLogo from "../../../assets/images/socialFollow/LinkedIn_Logo.png";
import websiteLogo from "../../../assets/images/socialFollow/Website_Logo.svg"; 


const SocialFollow: React.FC = () => {
	return (
		<div className={styles.container}>
			<p className={styles.title}>FOLLOW US ON</p>

			<div className={styles.socialIcons}>
				<a href="https://www.linkedin.com/company/instarails/" target="_blank" rel="noreferrer">
					<img src={linkedInLogo} alt="LinkedIn" className={styles.icon} />
				</a>

				<a href="https://instarails.net/" target="_blank" rel="noreferrer">
					<img src={websiteLogo} alt="Website" className={styles.icon} />
				</a>

				<a href="https://www.instagram.com/instarails_usa/" target="_blank" rel="noreferrer">
					<img src={instagramLogo} alt="Instagram" className={styles.icon} />
				</a>

				<a href="https://www.facebook.com/profile.php?id=61556658251240" target="_blank" rel="noreferrer">
					<img src={facebookLogo} alt="Facebook" className={styles.icon} />
				</a>
			</div>
		</div>
	);
};

export default SocialFollow;